import { useCallback, useEffect, useState } from 'react'

import {
  getUnreadInboxNotifications,
  useGetUnreadInboxNotificationsApiGateway,
  transformUnreadNotificationsResponse,
} from '@marketplace-web/inbox-notifications/inbox-notifications-data'
import { clientSideMetrics } from '@marketplace-web/observability/client-metrics-util'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

const handleFetchFailure = (response: any) => {
  const label = response?.status?.toString() || 'empty_response'
  clientSideMetrics.counter('notifications_count_fetch_failure', { label }).increment()
}

const useUnreadNotificationsCount = () => {
  const getUnreadInboxNotificationsApiGateway = useGetUnreadInboxNotificationsApiGateway()
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState<number>(0)
  const isApiGatewayClientEnabled = useFeatureSwitch('web_api_gateway_client')
  const isApiGatewayClientEnabledForInboxNotifications = useFeatureSwitch(
    'web_api_gateway_client_inbox_notifications',
  )
  const isApiGatewayEnabled =
    isApiGatewayClientEnabled && isApiGatewayClientEnabledForInboxNotifications

  const fetchUnreadNotificationsCount = useCallback(async () => {
    const response = isApiGatewayEnabled
      ? await getUnreadInboxNotificationsApiGateway()
      : await getUnreadInboxNotifications()

    if (!response || 'errors' in response) {
      handleFetchFailure(response)

      return
    }

    setUnreadNotificationsCount(transformUnreadNotificationsResponse(response))
  }, [isApiGatewayEnabled, getUnreadInboxNotificationsApiGateway])

  useEffect(() => {
    fetchUnreadNotificationsCount()
  }, [fetchUnreadNotificationsCount])

  return {
    unreadNotificationsCount,
    fetchUnreadNotificationsCount,
  }
}

export default useUnreadNotificationsCount
